__turbopack_context__.v({
  "lg": "spinner-module__z8pT-a__lg",
  "md": "spinner-module__z8pT-a__md",
  "neutral": "spinner-module__z8pT-a__neutral",
  "primary": "spinner-module__z8pT-a__primary",
  "sm": "spinner-module__z8pT-a__sm",
  "spinner": "spinner-module__z8pT-a__spinner",
  "xs": "spinner-module__z8pT-a__xs",
});
